import { render, staticRenderFns } from "./applyWithholdGold.vue?vue&type=template&id=4f15e98c&scoped=true"
import script from "./applyWithholdGold.vue?vue&type=script&lang=js"
export * from "./applyWithholdGold.vue?vue&type=script&lang=js"
import style0 from "./applyWithholdGold.vue?vue&type=style&index=0&id=4f15e98c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f15e98c",
  null
  
)

export default component.exports